/**
 * Mixin fournissant un AbortController pour annuler les requêtes CubeJS en cours
 * lors d'un changement de page ou d'un rechargement des données.
 *
 * Usage :
 *   import abortMixin from "@/mixins/abortMixin";
 *   export default {
 *     mixins: [abortMixin],
 *     methods: {
 *       async updateTableList(filters) {
 *         const { signal } = this.resetAbortController();
 *         // ...
 *         await TableTools.Helper.doMultipleRequest(queries, { signal });
 *       }
 *     }
 *   }
 */
export default {
  data() {
    return {
      abortControllers: {},
    };
  },
  methods: {
    /**
     * Annule les requêtes précédentes pour la clé donnée et crée un nouveau AbortController.
     * Chaque clé représente un flux de requêtes indépendant (ex: "table1", "table2").
     * Sans clé, utilise "default".
     * @param {string} [key="default"]
     * @returns {{ signal: AbortSignal }}
     */
    resetAbortController(key = "default") {
      if (this.abortControllers[key]) {
        this.abortControllers[key].abort();
      }
      this.abortControllers[key] = new AbortController();
      return { signal: this.abortControllers[key].signal };
    },
    /**
     * Vérifie si une erreur est due à une annulation volontaire.
     * @param {Error} error
     * @returns {boolean}
     */
    isAbortError(error) {
      return error && error.message === "aborted";
    },
  },
  beforeDestroy() {
    Object.values(this.abortControllers).forEach((c) => c.abort());
  },
};
